import prettyFormat from 'pretty-format'

interface Iobj {
  [propName: string]: any
}

/**
 * 格式化字符串
 * @param obj
 * @param min 默认最小化
 * @returns
 */
export function parseObjToString(obj: any, min = true): string {
  return prettyFormat(obj, { min, callToJSON: true })
}

/**
 * 把字符串转化为对象
 * @param str
 * @returns
 */
export function parseStringToObj(str: string): Iobj {
  try {
    return JSON.parse(str)
  } catch (error) {
    return {}
  }
}

/**
 * 下载json字符串到本地文件
 * @param str
 */
export function downloadLocalJson(str: string, filename?: string): void {
  //创建元素
  let ele = document.createElement('a')
  //设置下载文件名
  ele.download = filename && filename.endsWith('.json') ? filename : `${filename || 'data'}.json`
  //隐藏元素
  ele.style.display = 'none'
  //字符内容转变成blob地址
  let blob = new Blob([str])
  //如果是链接，这里也可以直接设置链接地址
  ele.href = URL.createObjectURL(blob)
  document.body.appendChild(ele)
  //模拟点击
  ele.click()
  //移除元素
  document.body.removeChild(ele)
}
